<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <template v-slot:extra>
        <!-- <a-button @click="backPage">返回</a-button> -->
      </template>
      <a-form layout="inline" class="topForm">
        <div>
          <a-form-item>
            <a-input
              v-model:value="searchForm.orderNo"
              placeholder="订单编号"
              allowClear
            />
          </a-form-item>

          <a-form-item>
            <a-input
              v-model:value="searchForm.passengerName"
              placeholder="购票人姓名"
              allowClear
            />
          </a-form-item>
          <a-form-item>
            <a-select
              v-model:value="searchForm.checkState"
              placeholder="对账状态"
              style="width: 200px"
              @search="fetchUser"
              @change="change"
              allowClear
            >
              <a-select-option
                v-for="d in checkStateData"
                :key="d.value"
                :value="d.value"
                :label="d.label"
              >
                {{ d.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-show="false">
            <a-range-picker
              v-model:value="searchForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="searchAction"> 查询 </a-button>
          </a-form-item>
        </div>
        <div>
          <a-form-item>
            <a-button @click="handleDownload">导出</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" disabled v-if="checkState == 20"
              >已对账</a-button
            >
            <a-button type="primary" @click="handleFinish" v-else
              >确认对账</a-button
            >
          </a-form-item>
        </div>
      </a-form>
    </a-card>
    <!-- table -->
    <a-card
      size="small"
      title=""
      style="margin-top: 20px"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      @tabChange="cardtabChange"
      :tabList="panes"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300, y: 800 }"
        :row-key="(r) => r.id"
        :loading="loading"
        class="log_content"
      >
        <template v-slot:orderNo="{ text, record }">
          <div @click="toDetail(record)">{{ record.orderNo }}</div>
        </template>
        <template v-slot:settlementAmount="{ text, record }">
          <div v-if="record.settlementAmount != null">
            ¥
            {{
              record.ticketTypeValue == "退票" || record.ticketTypeValue == "改签退票"
                ? "-" + record.settlementAmount
                : record.settlementAmount
            }}
            <!-- ¥ {{ record.settlementAmount }} -->
          </div>
        </template>
        <template v-slot:ticketAmount="{ text, record }">
          <div v-if="record.ticketAmount != null">
            ¥ {{ record.ticketAmount }}
          </div>
        </template>
        <template v-slot:postAmount="{ text, record }">
          <div v-if="record.postAmount != null">¥ {{ record.postAmount }}</div>
        </template>
        <template v-slot:insuranceAmount="{ text, record }">
          <div v-if="record.insuranceAmount != null">
            ¥ {{ record.insuranceAmount }}
          </div>
        </template>

        <template v-slot:returnServiceAmount="{ text, record }">
          <div v-if="record.returnServiceAmount != null">
            ¥ {{ record.returnServiceAmount }}
          </div>
        </template>

        <template v-slot:supplierName="{ text, record }">
<!--          <div v-if="record.supplierName == '东美'">
            {{ record.supplierName+'（直连代购）' }}
          </div>
          <div v-if="record.supplierName == '万顺'">
            {{ record.supplierName+'（专人代购）' }}
          </div>
          <div v-if="record.supplierName == '同城'">
            {{ record.supplierName+'（自购）' }}
          </div>-->
          {{ record.supplierName }}
        </template>

        <template v-slot:exReason="{ text, record }">
          <div class="redClass">{{ record.exReason }}</div>
        </template>
        <template v-slot:operation="{ text, record }">
          <a-button
            type="danger"
            @click="handleDelete(record)"
            size="small"
            style="margin-right: 10px"
          >
            删除
          </a-button>
        </template>
      </a-table>
    </a-card>
    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { ref, reactive, provide, createVNode } from "vue";
import financialApi from "@axios/financial";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "insurance",
  components: {
    ExclamationCircleOutlined,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const billNo = route.query.billNo;
      const orderNo = '';
    const id = route.query.id;
    const checkState = route.query.checkState;

    let activeKey = ref("0");
    let searchForm = reactive({
      billNo: "",
        orderNo: "",
      passengerName: "",
      checkState: "",
      orderdate: [],
    });

    let searchParams = reactive({
      billNo: "",
      passengerName: "",
      checkState: "",
        orderNo: "",
    });

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const searchAction = () => {
      searchParams.billNo = searchForm.billNo;
      searchParams.passengerName = searchForm.passengerName;
      searchParams.checkState = searchForm.checkState;
        searchParams.orderNo = searchForm.orderNo;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    let list = ref([]);

    let loading = ref(false);

    const getList = () => {
      let params = {
        ticketType: activeKey.value == "0" ? null : activeKey.value,
        billNo: searchParams.billNo ? searchParams.billNo : billNo,
          orderNo: searchParams.orderNo ? searchParams.orderNo : orderNo,
        passengerName: searchParams.passengerName
          ? searchParams.passengerName
          : null,
        checkState: searchParams.checkState ? searchParams.checkState : null,
        // checkBegin: searchParams.tktsStartTime ? searchParams.tktsStartTime : null,
        // checkEnd: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      loading.value = true;

      financialApi.getFinancialDetail(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    getList();

    const reset = () => {
      searchForm.supplierId = "";
      searchForm.orderdate = [];

      searchAction();
    };

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const handleDelete = (item) => {
      console.log(item);
    };

    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "出票", key: "10" },
      { tab: "改签", key: "20" },
      { tab: "退票", key: "30" },
    ]);
    const getDistributorCount = () => {
      let params = {
        billNo: billNo,
      };
      financialApi.getDistributorCount(params).then((res) => {
        console.log(res);
        panes.value = [
          { tab: `全部`, key: "0" },
          { tab: `出票(${res.buyType})`, key: "10" },
          { tab: `改签(${res.changesType})`, key: "20" },
          { tab: `退票(${res.returnType})`, key: "30" },
        ];
      });
    };
    getDistributorCount();

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    const backPage = () => {
      router.back();
    };

    // 导出
    const handleDownload = () => {
      let params = {
        billNo: billNo,
      };
      let fileName = "渠道结算单明细-" + billNo;
      exportOut(
        params, // 导出请求参数
        "/app-finance/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 确认对帐
    const handleFinish = () => {
      Modal.confirm({
        title: "是否确认对账？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.distributorFinish(id).then((res) => {
            console.log(res);
            message.success("确认对帐");
            getList();
          });
        },
        onCancel() {},
      });
    };

    const toDetail = (row) => {
      router.push({
        name: "orderDetail",
        query: {
          code: row.orderNo,
          type: "nomalOrder",
        },
      });
    };

    return {
      checkState,
      activeKey,
      cardtabChange,
      panes,
      handleDelete,
      loading,
      list,
      pageObj,
      searchForm,
      searchAction,
      reset,
      columns: [
        {
          title: "出票/改签/退票时间",
          dataIndex: "ticketTime",
          width: 160,
          align: "center",
          fixed: "left",
        },
        {
          title: "票号",
          dataIndex: "ticketNo",
          width: 120,
          align: "center",
          fixed: "left",
        },
        {
          title: "票种类型",
          dataIndex: "ticketTypeValue",
          width: 120,
          align: "center",
          fixed: "left",
        },
          {
              title: "改签类型",
              dataIndex: "changeTypeValue",
              width: 120,
              align: "center",
              fixed: "left",
          },
          {
              title: "订单号",
              dataIndex: "orderNo",
              width: 120,
              align: "center",
              className: `${"underlineStyle"}`,
              slots: { customRender: "orderNo" },
              fixed: "left",
          },
          {
              title: "原订单号",
              dataIndex: "changesNo",
              width: 120,
              align: "center",
              className: `${"underlineStyle"}`,
              fixed: "left",
          },
          {
              title: "退票单号",
              dataIndex: "returnNo",
              width: 120,
              align: "center",
              className: `${"underlineStyle"}`,
              fixed: "left",
          },
        {
          title: "渠道订单号",
          dataIndex: "channelCode",
          width: 120,
          align: "center",
          fixed: "left",
        },
       /* {
          title: "异常原因",
          dataIndex: "exReason",
          width: 120,
          align: "center",
          slots: { customRender: "exReason" },
          className: `${"columnStyle"}`,
          fixed: "left",
        },*/
        {
          title: "结算金额",
          dataIndex: "settlementAmount",
          width: 120,
          align: "center",
          slots: { customRender: "settlementAmount" },
        },
        {
          title: "票款",
          dataIndex: "ticketAmount",
          width: 120,
          align: "center",
          slots: { customRender: "ticketAmount" },
        },
          {
              title: "票数",
              dataIndex: "ticketCount",
              width: 120,
              align: "center",
              slots: { customRender: "ticketCount" },
          },
          /*  {
              title: "邮寄费",
              dataIndex: "postAmount",
              width: 100,
              align: "center",
              slots: { customRender: "postAmount" },
            },
            {
              title: "保险金额",
              dataIndex: "insuranceAmount",
              width: 100,
              align: "center",
              slots: { customRender: "insuranceAmount" },
            },
            {
              title: "保险数量",
              dataIndex: "insuranceCount",
              width: 100,
              align: "center",
            },*/
        {
          title: "手续费",
          dataIndex: "returnServiceAmount",
          width: 100,
          align: "center",
          slots: { customRender: "returnServiceAmount" },
        },
        {
          title: "出票模式",
          dataIndex: "ticketModeValue",
          width: 100,
          align: "center",
        },
        {
          title: "乘客姓名",
          dataIndex: "passengerName",
          width: 100,
          align: "center",
        },
        {
          title: "乘客类型",
          dataIndex: "passengerTypeValue",
          width: 100,
          align: "center",
        },
        {
          title: "出发日期",
          dataIndex: "trainTime",
          width: 200,
          align: "center",
        },
          {
              title: "是否打印票根",
              dataIndex: "enterpriseCodeValue",
              width: 100,
              align: "center",
          },
        {
          title: "出发站",
          dataIndex: "fromStation",
          width: 100,
          align: "center",
        },
        {
          title: "到达站",
          dataIndex: "toStation",
          width: 100,
          align: "center",
        },
          {
              title: "车次号",
              dataIndex: "trainNo",
              width: 100,
              align: "center",
          },
        {
          title: "供应商",
          dataIndex: "supplierName",
          width: 100,
          align: "center",
          slots: { customRender: "supplierName" },
          // className: `${"underlineStyle"}`
        },
          {
              title: "渠道商",
              dataIndex: "distributorName",
              width: 100,
              align: "center",
              slots: { customRender: "distributorName" },
              // className: `${"underlineStyle"}`
          },
     /*   {
          title: "退票唯一单号",
          dataIndex: "returnUniqueNo",
          width: 200,
          align: "center",
        },*/
        /*{
          title: "支付方式",
          dataIndex: "payWay",
          width: 100,
          align: "center",
          className: `${"underlineStyle"}`,
        },*/
      ],
      checkStateData: [
        {
          label: "未对账",
          value: "10",
        },
        {
          label: "已对账",
          value: "20",
        },
        {
          label: "异常",
          value: "90",
        },
      ],
      backPage,
      handleDownload,
      handleFinish,
      toDetail,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.log_content {
  .redClass {
    color: red;
  }
}
.topForm {
  display: flex;
  justify-content: space-between;
}
</style>
